import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "m-0" }
const _hoisted_3 = {
  key: 0,
  class: "ml-2 badge badge-pill badge-secondary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.member.name), 1),
      (_ctx.member.uid == _ctx.team.ownerId)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Owner"))
        : _createCommentVNode("", true),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-fill" }, null, -1)),
      (_ctx.shouldShowRemoveButton())
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn btn-outline-secondary btn-icon btn-menu invite-cancel",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.removeMember && _ctx.removeMember(...args))),
            title: "Remove from this team"
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("small", null, _toDisplayString(_ctx.member.email), 1)
  ]))
}